import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useLogLoginUIContext } from "../../LogLoginUIContext";
import { initialFilter } from "../../LogLoginUIHelper";
import AsyikSelect from "react-select/async";
import { findorganization } from "../../../../_redux/organization/organizationCrud";
import { genOptionLoaderDebounced } from "../../../../../../../_metronic/_helpers/fetchUtils";

const prepareFilter = (queryParams, values) => {
  const { name, organization_uuid } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  filter.organization_uuid = organization_uuid ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const LogLoginFilter = ({ listLoading }) => {
  // AccessRole UI Context
  const logLoginUIContext = useLogLoginUIContext();
  const logLoginUIProps = useMemo(() => {
    return {
      setQueryParams: logLoginUIContext.setQueryParams,
      queryParams: logLoginUIContext.queryParams,
      filterType: logLoginUIContext.filterType
    };
  }, [logLoginUIContext]);
  const [organization, setOrganization] = useState([]);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(logLoginUIProps.queryParams, values);
    if (!isEqual(newQueryParams, logLoginUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      logLoginUIProps.setQueryParams(newQueryParams);
    }
  };

  const fetchData = async () => {
    try {
      const res = await findorganization({
        pageNumber: 1,
        pageSize: 10,
        filter: {
          name: ''
        }
      });

      if (res.data.data) {
        setOrganization(res.data.data.items);
      }
     
    } catch (error) {
      console.error('Error fetching organization data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  },[])

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <label htmlFor="name">Nama</label>
              <input
                className="form-control"
                name="name"
                placeholder="Nama.."
                onBlur={handleBlur}
                value={values.name}
                onChange={e => {
                  setFieldValue("name", e.target.value);
                }}
              />
            </div>
            
            <div className="col-lg-4">
              <label htmlFor="name">Lembaga</label>
              <AsyikSelect
                defaultOptions={organization.map(({ name, uuid }) => ({
                  label: name,
                  value: uuid
                }))}
                loadOptions={genOptionLoaderDebounced(
                  inputValue =>
                    findorganization({
                      pageNumber: 1,
                      pageSize: 10,
                      filter: {
                        name: inputValue
                      }
                    }),
                  ({ uuid, name }) => ({ label: name, value: uuid })
                )}
                value={
                  values.organization_uuid
                    ? {
                        label: values.organization_name,
                        value: values.organization_uuid
                      }
                    : null
                }
                placeholder="Pilih Lembaga..."
                onChange={selected => {
                  const { label = "", value = "" } = selected ?? {};

                  setFieldValue("organization_name", label);
                  setFieldValue("organization_uuid", value);
                }}
                isClearable
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
